export default () =>
  new Promise((resolve) => {
    require.ensure([], () => {
      resolve({
        // eslint-disable-next-line
        chart: require('react-google-charts'),
      });
    });
  });



// WEBPACK FOOTER //
// ./src/loaders/ChartLoader/index.js